import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'privateNotes'] as const;

export const keys = {
  all,
  lists: () => [...all, 'lists'] as const,
  list: (spaceId: string) => [...keys.lists(), spaceId] as const,
};
